import * as React from "react";
import { Box, IconQuestionRegular, Inline, skinVars, Text1, Text2, Tooltip, useScreenSize } from "@telefonica/mistica";
import type { TextProps } from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";

export interface ITextListItemProps {
	title?: string;
	name: string;
	description: string;
	tooltipText?: string;
	tag?: React.ReactElement;
	nameProps?: TextProps;
	descripitionProps?: TextProps;
}

export const TextListItem: React.FC<ITextListItemProps> = (props) => {
	const { isDesktopOrBigger } = useScreenSize();
	const { description, name, tooltipText, title, tag, nameProps, descripitionProps } = props;

	return (
		<>
			<Inline space={"between"} alignItems="flex-end" fullWidth>
				<Inline space={4} alignItems={"center"}>
					<>
						{title && (
							<Box paddingBottom={4}>
								<Text1 regular color={skinVars.colors.backgroundBrand}>
									{title}
								</Text1>
							</Box>
						)}
						{typeof nameProps === "undefined" ? (
							<Text2 weight="medium" color={skinVars.colors.textPrimary}>
								{name}
							</Text2>
						) : (
							<Text {...nameProps}>{name}</Text>
						)}
					</>
					{tooltipText && (
						<Tooltip
							targetLabel={tooltipText}
							target={<IconQuestionRegular size={16} color={skinVars.colors.backgroundBrand} />}
							description={tooltipText}
							position={"top"}
							width={isDesktopOrBigger ? 343 : 250}
						/>
					)}
				</Inline>

				<Box className="text-align-right">
					{tag && tag}
					{typeof descripitionProps === "undefined" ? (
						<Text2 weight="regular" color={skinVars.colors.textSecondary}>
							{description}
						</Text2>
					) : (
						<Text {...descripitionProps}>{description}</Text>
					)}
				</Box>
			</Inline>
		</>
	);
};
